import CustomTable, { ICustomTableColumn } from '@/components/Table';

import SkeletonLoader from './index';

interface ITeacherDashboardSkeletonProps<T extends object> {
  columns: ICustomTableColumn<T>[];
}

const TeacherDashboardSkeleton = <T extends object>({
  columns,
}: ITeacherDashboardSkeletonProps<T>) => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-4 p-4 border border-neutral-200 rounded-xl bg-white"
          >
            <SkeletonLoader
              variant="rect"
              width={44}
              height={44}
              className="rounded-lg shrink-0"
            />
            <div className="flex flex-col gap-2 flex-1">
              <SkeletonLoader width="70%" height={14} />
              <SkeletonLoader width="40%" height={28} />
            </div>
          </div>
        ))}
      </div>

      {/* Assigned Classes Section */}
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <SkeletonLoader width={160} height={24} />
          <SkeletonLoader width={72} height={32} className="rounded-lg" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="rounded-2xl p-6 flex flex-col gap-6 bg-neutral-100"
            >
              <div className="flex items-center gap-2">
                <SkeletonLoader
                  variant="rect"
                  width={34}
                  height={34}
                  className="rounded-lg"
                />
                <SkeletonLoader width={100} height={22} />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <SkeletonLoader height={64} className="rounded-lg" />
                <SkeletonLoader height={64} className="rounded-lg" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Student Progress Section */}
      <div className="flex flex-col gap-4">
        <SkeletonLoader width={220} height={24} />
        <CustomTable columns={columns} dataSource={[]} isLoading={true} />
      </div>
    </div>
  );
};

export default TeacherDashboardSkeleton;
